import React, { useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
const ComponentSelector = ({ components, currentBundle, strings, currentIndex, selectNewComponent }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: 'start', skipSnaps: true });
    useEffect(() => {
        const placeholders = document.querySelectorAll('.product__component-select');
        if (placeholders) {
            placeholders.forEach((placeholder) => (placeholder.style.display = 'none'));
        }
    }, []);
    return (React.createElement("div", { className: "fg-cust--comp-select" }, components.map((component, index) => {
        if (component.products.length > 1) {
            const currentProduct = currentBundle[component.name];
            if (currentProduct.length) {
                return (React.createElement("div", { key: index, className: "fg-cust--comp-select__option-group" },
                    React.createElement("h3", { className: "fg-cust--comp-select__title" },
                        strings.part_choose_prefix,
                        " ",
                        component.name),
                    React.createElement("div", { className: "fg-cust--comp-select__wrapper" },
                        React.createElement("div", { className: "embla" },
                            React.createElement("div", { ref: emblaRef, className: "embla__viewport" },
                                React.createElement("div", { className: "embla__container" }, component.products.map((product, prodIndex) => (React.createElement("div", { key: prodIndex, className: "embla__slide" },
                                    React.createElement("button", { className: `fg-cust--comp-select__button ${currentProduct[0].product == product.part_type ? 'selected' : ''}`, onClick: () => selectNewComponent(component.name, product.part_type, currentIndex) }, product.title))))))))));
            }
        }
    })));
};
export default ComponentSelector;
